/**
 * 排出事業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/masters/tenant`

const tenant = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     *
     * @param _commit
     * @param subscriber_number
     * @return {Promise<unknown>}
     */
    show ({ _commit }, { subscriber_number }) {
      const params = { subscriber_number: subscriber_number }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default tenant

